import { render, staticRenderFns } from "./Supercampaign.vue?vue&type=template&id=55393304&"
import script from "./Supercampaign.vue?vue&type=script&lang=js&"
export * from "./Supercampaign.vue?vue&type=script&lang=js&"
import style0 from "./Supercampaign.vue?vue&type=style&index=0&id=55393304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports